import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

class SideBarProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  processStatus = status => (status === 'blacklisted' ? 'suspended' : status.split('_').join(' '));

  getStatusColor = status => {
    switch (status) {
      case 'signed_up':
      case 'operating':
        return '#128DFF';
      case 'subscribed':
        return '#767676';
      case 'negative_balance':
        return '#FF0000';
      case 'closed':
        return '#767676';
      default:
        return '#767676';
    }
  };
  render() {
    const { firstName, status, profileImage } = this.props;
    return (
      <Fragment>
        {status ? (
          <div className="profile__user">
            <div
              className="profile__user--image-container"
              style={{ border: `solid 2px ${this.getStatusColor(status)}` }}
              onClick={() => {
                const input = document.getElementById('edit_photo');
                input.click();
              }}>
              <img className="profile__user--image" src={profileImage} alt="user" />
              <div className="profile__user--image-upload">Edit</div>
            </div>
            <div className="profile__user--info">
              <div className="profile__user--first-name">{firstName}</div>
              <div className="profile__user--status">Status: {this.processStatus(status)}</div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default withRouter(SideBarProfile);



// WEBPACK FOOTER //
// ./src/components/NewProfile/User.js